import {useCombatants} from "@/encounter/combatants/CombatantHooks.ts";
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger
} from "@/components/ui/dropdown-menu.tsx";
import {Button} from "@/components/ui/button.tsx";
import {useTurn} from "@/encounter/turns/TurnHooks.ts";
import {Swords, TentTree, Undo2} from "lucide-react";

export default function CombatActions() {
    const {longRest} = useCombatants();
    const {resetCombat} = useTurn()
    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <Button variant="ghost" type="button" size="icon" title="Kampfaktionen"
                    className="data-[state=open]:bg-secondary"
                    aria-label="Kampfaktionen"><Swords/></Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent side="top" align="start">
                <DropdownMenuItem onSelect={longRest}><TentTree/>Lange Rast</DropdownMenuItem>
                <DropdownMenuItem onSelect={() => void resetCombat().catch(() => {})}><Undo2/>Kampf zurücksetzen</DropdownMenuItem>
            </DropdownMenuContent>
        </DropdownMenu>
    )
}
